import { render } from "./addNewAudit.vue?vue&type=template&id=39118984&scoped=true&ts=true"
import script from "./addNewAudit.vue?vue&type=script&lang=ts"
export * from "./addNewAudit.vue?vue&type=script&lang=ts"

import "./addNewAudit.vue?vue&type=style&index=0&id=39118984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39118984"]])

export default __exports__